
function AccordionService() {

    const _accordions = {};

    this.GetAccordions = () => {
        return _accordions;
    };

    this.Load = () => {
        for (let x in _accordions) {

            if (_accordions[x].IsOpen())
                _accordions[x].Open();

            const key = x;

            _accordions[x].AddClickEvent(() => { this.Toggle(key); });
        }
    }

    this.Open = (key) => {
        if (_accordions[key]) {
            _accordions[key].Open();
        }
    };

    this.Toggle = (key) => {

        if (_accordions[key]) {

            if (!_accordions[key].IsOpen()) {
                // Open active accordion
                _accordions[key].Open();
                // Close all others
                for (let x in _accordions) {
                    if (x !== key)
                        _accordions[x].Close();
                }
            } else {
                // Close active accordion
                _accordions[key].Close();
            }            
        }
    };

    this.TryAddElement = (element) => {

        const key = element.dataset['key'];

        if (key !== undefined) {

            if (!_accordions[key])
                _accordions[key] = new Accordion(key);

            const type = element.dataset['type'];

            if (type === 'header') {
                _accordions[key].SetHeader(element);

                const isOpen = element.dataset['open'];

                if (isOpen !== undefined && isOpen.toLowerCase() === 'true')
                    _accordions[key].SetIsOpen(true);
            }
            else if (type === 'panel') {
                _accordions[key].SetPanel(element);
            }   
        }
    }    
}

function Accordion(key) {

    let _key = key;
    let _header = undefined;
    let _panel = undefined;
    let _isOpen = false;

    function AddClassToHeader(className) {
        if (_header && _header.classList && !_header.classList.contains(className))
            _header.classList.add(className);
    }

    function CloseHeader() {
        if (_header) {
            RemoveClassFromHeader('active');
            _header.children[0].style = null;
            _header.style = null;
        }
    }

    function ClosePanel() {
        if (_panel) {
            _panel.style.maxHeight = null;
        }
    }

    function OpenHeader() {
        if (_header) {
            AddClassToHeader('active');
            _header.children[0].style = "transform: rotateZ(-180deg);";
            _header.style.border = "0";  
        }
    }

    function OpenPanel() {
        if (_panel) {
            _panel.style.maxHeight = _panel.scrollHeight + "px";
        }
    }

    function RemoveClassFromHeader (className) {
        if (_header && _header.classList && _header.classList.contains(className))
            _header.classList.remove(className);
    }

    this.AddClickEvent = (fn) => {
        if (_header) {
            _header.addEventListener('click', fn);
        }
    };

    this.Close = () => {
        ClosePanel();
        CloseHeader();
        _isOpen = false;
        _header.dataset['open'] = 'false';
    };

    this.IsOpen = () => {
        return _isOpen;
    };

    this.Open = () => {    
        OpenPanel();
        OpenHeader();
        _isOpen = true;
        _header.dataset['open'] = 'true';
    }

    this.SetHeader = (header) => {
        _header = header;
    };

    this.SetIsOpen = (isOpen) => {
        _isOpen = isOpen;
    };

    this.SetPanel = (panel) => {
        _panel = panel;
    };
}

export default async accordion => { // <div comp-accordion />

    const _svc = new AccordionService();

    for (let i = 0, l = accordion.children.length; i < l; i++) {
        _svc.TryAddElement(accordion.children[i]);
    }
    
    _svc.Load();
};